import React from 'react';
import { CheckIcon, FlameIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const bundle = [{
  emoji: '🤖',
  label: 'MakerLab — 100+ Roboter-Projekte',
  value: '47,00 €'
}, {
  emoji: '🎥',
  label: 'Bonus #1: Cardboard Arcade Pack',
  value: '25,00 €'
}, {
  emoji: '✂️',
  label: 'Bonus #2: Der 5-Minuten-Papercraft-Guide',
  value: '19,00 €'
}, {
  emoji: '🌈',
  label: 'Bonus #3: Kleine Kreative: Slime & Sensorik',
  value: '19,00 €'
}];
export function Offer() {
  return <section id="angebot" className="w-full bg-cream py-16 sm:py-24" data-id="element-119">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-120">
        <SectionHeading eyebrow="✦ Alles, was du heute bekommst" title={<>Das komplette MakerLab-Paket</>} data-id="element-121" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-xl" data-id="element-122">
          <ul className="divide-y divide-ink/10" data-id="element-123">
            {bundle.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-124">
                <span className="flex items-center gap-3 text-sm font-semibold text-ink" data-id="element-125">
                  <span className="text-xl" aria-hidden="true" data-id="element-126">
                    {item.emoji}
                  </span>
                  {item.label}
                </span>
                <span className="flex-none text-sm font-medium text-ink/40 line-through" data-id="element-127">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="space-y-2 bg-ink px-6 py-8 text-center text-white" data-id="element-128">
            <p className="text-sm text-white/60" data-id="element-129">
              Gesamtwert <span className="line-through" data-id="element-130">110,00 €</span>
            </p>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wide text-brand" data-id="element-131">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-132" />
              Du zahlst heute nur
            </p>
            <p className="font-display text-5xl font-black" data-id="element-133">27,00 €</p>
            <p className="text-sm font-semibold text-emerald-400" data-id="element-134">
              🎉 Du sparst heute 83,00 €
            </p>

            <div className="pt-4" data-id="element-135">
              <CtaButton className="w-full sm:w-auto" data-id="element-136">
                Ja! Ich will alles für nur 27 €
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-col items-center gap-2 text-sm text-white/70 sm:flex-row sm:justify-center sm:gap-6" data-id="element-137">
              {['Sofortiger digitaler Zugriff', 'Alle 3 Boni enthalten', 'Einmalzahlung, kein Abo'].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-138">
                  <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-139" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink/50" data-id="element-140">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" />
          Sofortiger Zugriff nach dem Kauf · +40.938 Downloads
        </p>
      </div>
    </section>;
}